import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R } from 'core/helpers'
import { isNotFoundError } from 'core/helpers/error'
import { useCompanyLoanConfigurationsGet } from 'core/types'

import ModelLink from './ModelLink'

type LoanTypeLinkProps = {
  loanTypeId: string
}

const LoanTypeLink: FC<LoanTypeLinkProps> = ({ loanTypeId }) => {
  const [_, { companyId }] = useQueryApi()
  const { data: loanType, isLoading } = useCompanyLoanConfigurationsGet({
    companyId,
    loanTypeId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  return <ModelLink id={loanTypeId} isLoading={isLoading} model={loanType} />
}

export default LoanTypeLink
